import API_BASE_URL from './api';

export async function fetchTeam() {
  const r = await fetch(`${API_BASE_URL}/api/team`);
  if (!r.ok) throw new Error('Erreur chargement équipe');
  return r.json();
}

export async function fetchTeamMember(slug) {
  const r = await fetch(`${API_BASE_URL}/api/team/${encodeURIComponent(slug)}`);
  if (!r.ok) throw new Error('Profil introuvable');
  return r.json();
}

export async function deleteTeamMember(slug, token) {
  const r = await fetch(`${API_BASE_URL}/api/admin/team/${encodeURIComponent(slug)}`, {
    method: 'DELETE',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!r.ok) throw new Error('Erreur suppression du profil');
  return r.json();
}